type TRole = 'creator' | 'admin' | 'animator' | 'hozanaAdmin'

export type TPermissionsMap = {
  isCreator: boolean
  isAdmin: boolean
  isAnimator: boolean
  user: {
    admin: boolean
  }
}

export type TPermissions = {
  canManageRoles: boolean
  canSendAnnouncements: boolean
  canManageContent: boolean
  canView: boolean
  canAdmin?: boolean
}

export const rolePermissions: Record<TRole, TPermissions> = {
  creator: {
    canManageRoles: true,
    canSendAnnouncements: true,
    canManageContent: true,
    canView: true,
  },
  admin: {
    canManageRoles: true,
    canSendAnnouncements: true,
    canManageContent: true,
    canView: true,
  },
  animator: {
    canManageRoles: false,
    canSendAnnouncements: false,
    canManageContent: true,
    canView: true,
  },
  hozanaAdmin: {
    canManageRoles: true,
    canSendAnnouncements: true,
    canManageContent: true,
    canView: true,
    canAdmin: true,
  },
}

export type TPermissionKey = keyof TPermissions
